export const COUPON_EVENT_COUPON_TYPE = ['type'];
export const COUPON_EVENT_COUPON = ['couponRate'];
export const COUPON_EVENT_DENOMINATION = ['denomination'];
export const COUPON_EVENT_DAY_COUNT_FRACTION = ['dayCountFraction'];
export const COUPON_EVENT_SCHEDULE_START = ['periodStart'];
export const COUPON_EVENT_SCHEDULE_END = ['periodEnd'];
export const COUPON_EVENT_SCHEDULE_PAYMENT_DATE = ['paymentDate'];
export const COUPON_EVENT_SCHEDULE_FIXING_DATE = ['observationDate'];
export const COUPON_EVENT_TOUCH_BREAK = ['barrier', 'touchAndBreak'];
export const COUPON_EVENT_BARRIER_LEVEL = ['barrier', 'level'];
export const COUPON_EVENT_REFERENCE_RATE = ['referenceRate', 'name'];
export const COUPON_EVENT_REFERENCE_RATE_FIX = ['referenceRate', 'amount'];
export const COUPON_EVENT_FLOOR = ['floor'];
export const COUPON_EVENT_CAP = ['cap'];
export const COUPON_EVENT_CURRENCY = ['currency'];
export const COUPON_EVENT_MULTIPLIER = ['multiplier'];
export const COUPON_EVENT_SPREAD = ['spread'];
export const COUPON_EVENT_AMOUNT = ['amount'];

export const COUPON_EVENT_SCHEDULE_START_END = [
  COUPON_EVENT_SCHEDULE_START,
  COUPON_EVENT_SCHEDULE_END,
];
export const COUPON_EVENT_SCHEDULE_PAYMENT_FIXING = [
  COUPON_EVENT_SCHEDULE_PAYMENT_DATE,
  COUPON_EVENT_SCHEDULE_FIXING_DATE,
];
export const COUPON_EVENT_CAP_FLOOR = [COUPON_EVENT_CAP, COUPON_EVENT_FLOOR];
export const COUPON_EVENT_BARRIER_TOUCH = [
  COUPON_EVENT_TOUCH_BREAK,
  COUPON_EVENT_BARRIER_LEVEL,
];
